import { Fragment } from "react";
import styled from "styled-components";
import { Switch } from "./Switch";
import { Spacer } from "./Spacer";
import { TextCapitalized } from "./text/TextCapitalized";
import { colors } from "../../styles/figmaColors";

export interface ToggleItem {
  label?: string;
  checked: boolean;
  onClick: () => void;
  disabled?: boolean;
}

export interface TogglesGroupCellProps {
  primaryToggle: ToggleItem;
  secondaryToggles: ToggleItem[];
}

export const TogglesGroupCell = (props: TogglesGroupCellProps) => {
  const hasOneToggleChecked = props.secondaryToggles.some(
    (toggle) => toggle.checked,
  );

  return (
    <StyledCell>
      <StyledPrimaryToggle>
        {props.primaryToggle.label && (
          <>
            <TextCapitalized>{props.primaryToggle.label}</TextCapitalized>
            <Spacer y={0.5} />
          </>
        )}
        <Switch
          checked={props.primaryToggle.checked}
          onClick={props.primaryToggle.onClick}
          disabled={hasOneToggleChecked}
          size={"S"}
        />
      </StyledPrimaryToggle>
      <Spacer x={1} />
      <StyledSeparatorArea>
        <Spacer y={1} />
        <StyledSeparator />
        <Spacer y={1} />
      </StyledSeparatorArea>
      <Spacer x={1} />
      <StyledToggles>
        <Spacer y={1} />
        {props.secondaryToggles.map((toggle, index) => (
          <Fragment key={index}>
            <StyledToggleLine>
              <Switch
                checked={toggle.checked}
                onClick={toggle.onClick}
                disabled={toggle.disabled || !props.primaryToggle.checked}
                size={"S"}
              />
              {toggle.label && (
                <>
                  <Spacer x={0.5} />
                  <TextCapitalized>{toggle.label}</TextCapitalized>
                </>
              )}
            </StyledToggleLine>
            <Spacer y={0.75} />
          </Fragment>
        ))}
      </StyledToggles>
    </StyledCell>
  );
};

const StyledCell = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  line-height: 1.5rem;
`;

const StyledPrimaryToggle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const StyledSeparatorArea = styled.div`
  display: flex;
  flex-direction: column;
  align-self: stretch;
`;

const StyledSeparator = styled.div`
  border-left: 0.0625rem solid ${colors["colors/borders/separator/cells"]};
  flex: 1;
`;

const StyledToggles = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const StyledToggleLine = styled.div`
  display: flex;
  align-items: center;
`;
